import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useProductTrustProps } from "./useProductTrustProps";
export default function TrustProps() {
  const $ = _c(4);
  const trustPropItems = useProductTrustProps();
  if (trustPropItems.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== trustPropItems) {
    t0 = trustPropItems.map(_temp);
    $[0] = trustPropItems;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="pt-3 flex flex-col gap-4 border-t border-border md:flex-row md:flex-wrap">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(item) {
  return <div key={item.id} className="flex items-center gap-1 text-xs text-foreground">{item.icon ? <Image src={item.icon.src} alt={item.icon.alt} width={14} height={14} className="h-3.5 w-3.5 shrink-0 object-scale-down" /> : null}<p>{item.text}</p></div>;
}